import React from "react";

const ReturnRefundPolicy = () => {
  return (
    <section className="terms">
      <div className="row">
        <h2>RETURN & REFUND POLICY</h2>
      </div>

      <div className="row content">
        <div>
          <p>
            Thank you for shopping with <strong>MERIGOLD</strong>! We are committed to providing you with a great experience. If you are not entirely satisfied with your purchase, we’re here to help.
          </p>

          <p><strong>1. Return Window</strong></p>
          <p>
            •	You have 2 calendar days from the date you received your item to initiate a return.
          </p>

          <p><strong>2. Eligibility for a Return</strong></p>
          <p>To be eligible for a return, your item must meet the following conditions:</p>
          <p><strong>•	Condition: </strong>The item must be <strong> unused, unworn, unwashed, and in the same condition</strong> that you received it.</p>
          <p><strong>•	Original Packaging: </strong>The item must be in its original packaging, including any protective wrapping or boxes.</p>
          <p><strong>•	Tags and Labels: </strong>All original tags, labels, and hygiene strips (if applicable) must be attached.</p>
          <p><strong>•	Proof of Purchase: </strong>You must have the receipt or proof of purchase (e.g., your order number).</p>

          <p><strong>3. Non-Returnable Items</strong></p>
          <p>The following items are <strong>final sale</strong> and cannot be returned or exchanged for safety and hygiene reasons:</p>
          <p>• Perishable goods (e.g., food, flowers)</p>
          <p>• Personalized or custom-made products</p>
          <p>• Certain health and personal care items (e.g., cosmetics, earrings, underwear, swimwear)</p>

          <p><strong>4. Return Options</strong></p>
          <p>Upon inspection and approval of your returned item, we offer the following options:</p>
          <p><strong>• Full Refund:</strong> A full refund will be issued to your original method of payment.</p>
          <p><strong>• Store Credit:</strong> We can issue a credit for the full amount of the purchase to be used on future orders.</p>
          <p><strong>• Exchange:</strong> You may exchange the item for a different size or color of the same product, subject to availability.</p>

          <p><strong>5. How to Initiate a Return</strong></p>
          <p>Please follow these steps to ensure a smooth return process:</p>
          <p><strong>1.	Contact Us:</strong> Email us at <a href="mailto:support@merigold.care">support@merigold.care</a> or visit our online <strong>Return Portal at</strong> <a href="https://merigold.care">merigold.care</a> within the return window. Please include your Order Number and the reason for the return.
          </p>
          <p>
            <strong>2.	Receive Authorization:</strong> Our customer support team will review your request and, if approved, will provide you with a <strong>Return Merchandise Authorization (RMA) number</strong> and the team will contact you and provide you details on how to proceed.
          </p>
          <p>
            <strong>3.	Package the Item:</strong> Carefully package the item(s) in the original packaging. Write the RMA number clearly on the outside of the box.
          </p>
          <p><strong>4.	Ship the Item:</strong> Drop off the package at your nearest USPS or UPS location using the pre-paid label provided.</p>

          <p><strong>6. Return Shipping Costs</strong></p>
          <p><strong>•	Our Error:</strong> If the return is due to our error (e.g., you received a damaged, defective, or incorrect item), we will cover <strong>100% of the return shipping costs.</strong></p>
          <p>
            <strong>•	Customer Choice:</strong> If the return is due to a change of mind or an incorrect item ordered by the <strong>customer, the customer will be responsible for the return shipping costs,</strong> which will be deducted from your final refund amount.
          </p>

          <p><strong>7. Refund Processing</strong></p>
          <p>
            •	Once we receive your returned item, it will be inspected. We will notify you via email of the status of your refund after completing the inspection.
          </p>
          <p>
            •	If approved, your refund will be processed, and a credit will automatically be applied to your original method of payment within <strong>120</strong> business days. Processing times may vary depending on your bank or payment provider.
          </p>

          <p><strong>8. Damaged or Defective Items</strong></p>
          <p>
            If your item arrives damaged or defective, contact us <strong>immediately</strong> within <strong>24 hours</strong> of delivery at <a href="mailto:support@merigold.care">support@merigold.care</a>. We will work quickly to replace the product or issue a full refund, and we will cover all associated return shipping costs.
          </p>

          <p><strong>9. Issues with Order Fulfillment (Non-Delivered Products)</strong></p>
          <p>
            In rare cases, your order may be accepted and paid for, but we may be unable to fulfill the delivery due to circumstances outside our immediate control, such as:
          </p>
          <p><strong>•	Supplier Stock Issues:</strong> The manufacturer or supplier unexpectedly runs out of stock or discontinues the item after your order was placed.</p>
          <p><strong>•	Quality Control Failures:</strong> The product fails our final quality check before shipping and no replacement stock is available.</p>
          <p><strong>•	Logistics or Import Delays:</strong> Unforeseen regulatory or import issues prevent the product from reaching our warehouse for shipment.</p>

          <p><strong>Procedure for Non-Delivery</strong></p>
          <p>
            <strong>1.	Notification:</strong> If we determine that we cannot fulfill your order, we will notify you immediately via email, typically within 5 business days of placing your order.
          </p>
          <p><strong>2.	Options:</strong> We will offer you the choice of:</p>
          <p><strong>◦	Full Refund:</strong> A complete refund for the non-delivered item(s) to your original method of payment.</p>
          <p><strong>◦	Store Credit:</strong> Issuance of store credit for the full purchase amount, plus a small goodwill bonus to compensate for the inconvenience.
          </p>
          <p><strong>3.	Refund Processing:</strong> If you choose a refund, it will be processed immediately upon your confirmation. The credit will appear in your account within <strong>120 business days</strong>.
          </p>

          <p>
            We sincerely apologize for any inconvenience caused by supplier or fulfillment issues and appreciate your understanding.
          </p>

          <p><strong>Need Help?</strong></p>
          <p>If you have any questions regarding your return, please contact our customer support team:</p>
          <p><strong>•	Email: </strong><a href="mailto:support@merigold.care">support@merigold.care</a></p>
          <p><strong>•	Phone: </strong><strong>+1-888-598-1651 | 3022235619</strong></p>
          <p><strong>•	Hours: </strong>24/7 Customer Support</p>
        </div>
      </div>
    </section>
  );
};

export default ReturnRefundPolicy;
